module.exports = __webpack_public_path__ + "img/p__辽宁.51186d0a.png";